import { createRouter, createWebHistory } from "vue-router";

import { useAuthStore } from "@/stores";
import HomeView from "@/views/HomeView.vue";
import { notify } from "@kyvg/vue3-notification";

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  linkActiveClass: "active",
  routes: [
    { path: "/", component: () => import("@/views/ProductView.vue") },
    { path: "/about", component: HomeView },
    { path: "/docs", component: () => import("@/views/DocsView.vue") },
    { path: "/docs/:id", component: () => import("@/views/DocView.vue") },
    { path: "/account/login", component: () => import("@/views/Register.vue") },
    {
      path: "/objects",
      component: () => import("@/views/admin/ObjList.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/users",
      component: () => import("@/views/admin/UserList.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/account",
      component: () => import("@/views/user/Account.vue"),
      meta: { requiresAuth: true },
    },
  ],
});

router.beforeEach(async (to) => {
  const authStore = useAuthStore();
  const isAuthentificated = authStore.isAuthentificated;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (requiresAuth && !isAuthentificated) {
    notify({
      title: "Отказано в доступе",
      text: "Требуется войти в аккаут",
      type: "warning",
    });
    authStore.returnUrl = to.fullPath;
    return "/account/login";
  }
});
